import React from 'react';
import { Copy, Mail } from 'lucide-react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogBody,
  DialogTitle
} from '../../../../components/ui/Dialog';
import Button from '../../../../components/ui/Button';

interface ShareModalProps {
  isOpen: boolean;
  profileUrl: string;
  onClose: () => void;
  onCopyLink: () => void;
  t: (key: string) => string;
}

const ShareModal: React.FC<ShareModalProps> = ({
  isOpen,
  profileUrl,
  onClose,
  onCopyLink,
  t
}) => {
  const handleShareViaEmail = () => {
    window.open(
      `mailto:?subject=${encodeURIComponent(t('Check out my public profile'))}&body=${encodeURIComponent(profileUrl)}`,
      '_blank'
    );
    onClose();
  };

  const handleCopyAndClose = () => {
    onCopyLink();
    onClose();
  };

  return (
    <Dialog open={isOpen} onOpenChange={(open) => { if (!open) onClose(); }}>
      <DialogContent size="sm">
        <DialogHeader>
          <DialogTitle>{t('Share Profile')}</DialogTitle>
        </DialogHeader>
        <DialogBody className="space-y-3">
          <Button
            variant="ghost"
            fullWidth
            onClick={handleCopyAndClose}
            className="justify-start gap-3 bg-muted hover:bg-accent px-4 py-3"
          >
            <Copy className="w-5 h-5" />
            {t('Copy Link')}
          </Button>
          <Button
            variant="ghost"
            fullWidth
            onClick={handleShareViaEmail}
            className="justify-start gap-3 bg-muted hover:bg-accent px-4 py-3"
          >
            <Mail className="w-5 h-5" />
            {t('Share via Email')}
          </Button>
        </DialogBody>
      </DialogContent>
    </Dialog>
  );
};

export default ShareModal;
